import { IGlobalSearchResult } from './i-globalsearchresult.interface';

export class GlobalSearchResult implements IGlobalSearchResult {
	type: string;
	id: string;
	name: string;

  constructor(type: string, id: string, name: string) {
	  this.type = type;
	  this.id = id;
	  this.name = name;
  }
}